import { DateTimeExtension } from '80.quickConnect.Core/formatting/DateTimeExtension';

export default function mapAllFieldTypeValuesToDateTime(value: unknown): Date | null | undefined {
  if (value instanceof Date) return value;
  else if (value === null || value === '') return null;
  else if (typeof value === 'string') return DateTimeExtension.parseMultiFormat(value) ?? undefined;
  else if (typeof value === 'number') return DateTimeExtension.mapFromNumber(value) ?? undefined;
  else return;
}
